var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTargetActualIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 9.5,
    r: 9.5,
    fill: "#FFF3E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.9375C2.5 14.4197 2.91973 14 3.4375 14H5.3125C5.83027 14 6.25 14.4197 6.25 14.9375V20.5625C6.25 21.0803 5.83027 21.5 5.3125 21.5H3.4375C2.91973 21.5 2.5 21.0803 2.5 20.5625V14.9375Z",
    stroke: "#F57C00",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 11.1875C8.125 10.6697 8.54473 10.25 9.0625 10.25H10.9375C11.4553 10.25 11.875 10.6697 11.875 11.1875V20.5625C11.875 21.0803 11.4553 21.5 10.9375 21.5H9.0625C8.54473 21.5 8.125 21.0803 8.125 20.5625V11.1875Z",
    stroke: "#F57C00",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.4375C13.75 6.91973 14.1697 6.5 14.6875 6.5H16.5625C17.0803 6.5 17.5 6.91973 17.5 7.4375V20.5625C17.5 21.0803 17.0803 21.5 16.5625 21.5H14.6875C14.1697 21.5 13.75 21.0803 13.75 20.5625V7.4375Z",
    stroke: "#F57C00",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetActualIcon);
export default __webpack_public_path__ + "static/media/target_actual_icon.642485da5eb320078726c5756bcf68fd.svg";
export { ForwardRef as ReactComponent };